import cache_data_siteSetting from "@core/helpers/server/cache-data/siteSetting";
import { fnv1a } from "@core/helpers/string";

export const get_currency_server = async () => {
	const siteDetail = await cache_data_siteSetting();
	return siteDetail?.web_currency || "";
};

// STORAGE_PREFIX_URL (optional, per site): used while the settings could not be read. Without a prefix every file saved
// as a relative path ("upload/....webp") became "/upload/..." on the site and answered 404.
export const get_storage_prefix_url_server = async () => {
	const siteDetail = await cache_data_siteSetting();
	return siteDetail?.web_storage_prefix_url || process.env.STORAGE_PREFIX_URL || "";
};

export const get_site_status_server = async () => {
	const siteDetail = await cache_data_siteSetting();
	return parseInt(siteDetail?.site_status) || 0;
};

export const get_site_status_information_server = async () => {
	const { get_cookie } = require("@core/helpers/cookie");
	const status_code = await get_site_status_server();

	const map_status = {
		0: "undefined",
		1: "none",
		2: "updating",
		3: "repairing",
		4: "coming soon",
		5: "technical test",
	};

	const access_id = await get_cookie("_access_id");
	// todo: call api
	// the cookie is awaited first: `await get_cookie(...)?.length` read `.length` of the promise, so a signed-in
	// visitor never got past the block page
	const has_access =
		(await get_cookie("_token"))?.length > 0 &&
		!["null", null, undefined, "undefined"].includes(access_id) &&
		access_id?.length > 0;

	return {
		status_code,
		description: `site_status.description.${map_status?.[status_code] || map_status?.[0]
			}`,
		has_block_page: ![0, 1, 5]?.includes(status_code) && !has_access,
	};
};

export const get_all_web_settings = async () => {
	return {
		web_site_currency: await get_currency_server(),
		web_site_storage_prefix_url: await get_storage_prefix_url_server(),
	};
};

export const get_route_names_server = async () => {
	const { get_default_locate_server } = require("./locate");
	const { get_current_locate_from_cookie } = require("@core/helpers/locate");

	const siteDetail = await cache_data_siteSetting();
	const current_locale = await get_current_locate_from_cookie();
	const default_locale = await get_default_locate_server();
	let route_names = { ...(siteDetail?.route_names || {}) };

	if (current_locale !== default_locale) {
		for (const key in route_names) {
			route_names[key] = `/${current_locale}${route_names[key]}`;
		}
	}
	return route_names;
};

export const get_config_keys_server = async () => {
	const siteDetail = await cache_data_siteSetting();
	return siteDetail?.config_keys || [];
}

// Server twin of WebSiteContext's `check_service_access(key)`: is the panel service `key` (e.g. "TOROB_PRODUCT_LIST",
// "USING_CUSTOMER_IN_CHECKOUT_PAGE") on for this site? Reads the cached site settings, no extra request. Added for
// chawk-bazar / ciseco, whose wallet page 404s on the server when the module is off (they hashed the key themselves).
export const check_service_access_server = async (key) => {
	if (!key) return false;
	const config_keys = await get_config_keys_server();
	return Array.isArray(config_keys) && config_keys.includes(fnv1a(`service_key|${key}`));
}


export const get_logo_site_server = async () => {
	const siteDetail = await cache_data_siteSetting();
	return siteDetail?.logo_site || "";
}